import { useDebouncedSearch } from '@/components/Form/pickers/hooks';

import Combobox, { type ComboboxProps } from './Combobox';

export type DebouncedComboboxProps<
  Value,
  Multiple extends boolean | undefined = false,
> = ComboboxProps<Value, Multiple> & {
  onSearch?: (search: string) => void;
  searchDebounceMs?: number;
};

const DebouncedCombobox = <Value, Multiple extends boolean | undefined = false>({
  onSearch,
  searchDebounceMs,
  onInputValueChange,
  ...props
}: DebouncedComboboxProps<Value, Multiple>) => {
  const { onInputValueChange: onDebouncedInputValueChange } = useDebouncedSearch({
    onSearch,
    debounceMs: searchDebounceMs,
  });

  const handleInputValueChange: ComboboxProps<Value, Multiple>['onInputValueChange'] = (
    value,
    eventDetails,
  ) => {
    onDebouncedInputValueChange(value);
    onInputValueChange?.(value, eventDetails);
  };

  return <Combobox {...props} onInputValueChange={handleInputValueChange} />;
};

export default DebouncedCombobox;
